module.exports = __webpack_public_path__ + "img/straight_line_icon_124.b8054e46.svg";